var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReact01(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 28.4 28.4",
    style: {
      enableBackground: "new 0 0 28.4 28.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.46;fill:#65ABCE;enable-background:new    ;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.3,14.6c-0.2,3.2-3,5.3-4.6,6.5c-2.9,2.1-5.9,2.6-7.6,2.7c-0.9,0.1-5.3,0.2-9.3-2.7C4.5,20.2,2.8,19,2,16.8 C0.5,13,1.9,8.2,4.3,7.2C4.9,6.9,5,6.9,8.6,6.8c0.7,0,1.6-0.1,2.6-0.3c4.4-0.8,4.9-2.4,7.3-1.9c2.3,0.5,4.1,1.9,5.4,3.2 C25.3,9.3,27.5,11.5,27.3,14.6z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReact01);
export default __webpack_public_path__ + "static/media/react01.9c31143b17bee1f5d26bc3cc5c07597e.svg";
export { ForwardRef as ReactComponent };